import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonHelper } from '../../../../utilities/common.helper';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { LoaderService } from '../../../sharedServices/loader.service';
import { SharedService } from '../../../sharedServices/shared.service';
import { ApprovedDetailsService } from './services/approved-details.service';

@Component({
  selector: 'kt-approved-details',
  templateUrl: './approved-details.component.html',
  styleUrls: ['./approved-details.component.css']
})
export class ApprovedDetailsComponent implements OnInit {
  @Input()applicationId:number;
  @Input() btnCancelText: string = 'Cancel';
  public step:number = 0;
  public loader:boolean=false;
  public approvedDetailsList:any;
  /** Old applications expose `stampNumberFrom`; new ones send null on first stamp row — hide stamp # / attestation type columns. */
  showStampNumberAndAttestationTypeColumns = true;
  /** Letter download column — only when first stamp row has `stampNumberFrom` null (new application). */
  showApprovedLetterColumn = false;
  /** Per `dasDegreeId` while `GET …/generateLetter/{id}` is in flight. */
  private letterDownloadInFlight: Record<string, boolean> = {};
  /** Cached from profile/getPersonalDetails (`data.cnic`) — fetched once for letter download. */
  private userCnic: string = '';
  private personalDetailsInFlight = false;

  constructor(private dialogRef: MatDialogRef<ApprovedDetailsComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService:SharedService,private loaderService:LoaderService,private approvedDetailService:ApprovedDetailsService
    ) { }

  ngOnInit() {
    this.applicationId = this.data.appId;
    console.log(this.applicationId)
    this.getApprovedApplicationDetails(this.applicationId)
  }

  public getDate(date):void {
    return this.sharedService.getDate(date);
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  isLetterDownloading(degreeId: any): boolean {
    return !!this.letterDownloadInFlight[String(degreeId)];
  }

  onDownloadApprovedLetter(details: any): void {
    if (!this.showApprovedLetterColumn) {
      return;
    }
    const degreeId = details && details.degreeId;
    if (degreeId == null || String(degreeId).trim() === '') {
      return;
    }
    const key = String(degreeId);
    if (this.letterDownloadInFlight[key] || this.personalDetailsInFlight) {
      return;
    }
    if (this.userCnic) {
      this.downloadApprovedLetter(degreeId, key);
      return;
    }
    this.personalDetailsInFlight = true;
    this.loader = true;
    this.loaderService.setValue(this.loader);
    this.sharedService.getPersonalDetails().subscribe(
      (res) => {
        this.personalDetailsInFlight = false;
        if (res && res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data) {
          this.userCnic = this.extractCnicFromPersonalDetails(res.data);
        }
        if (!this.userCnic) {
          this.loader = false;
          this.loaderService.setValue(this.loader);
          this.sharedService
            .openPopupDialog(
              'ERROR',
              HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
              HEC_CONSTANTS.ERROR_TYPES.error
            )
            .then(() => {});
          return;
        }
        this.downloadApprovedLetter(degreeId, key);
      },
      () => {
        this.personalDetailsInFlight = false;
        this.loader = false;
        this.loaderService.setValue(this.loader);
        this.sharedService
          .openPopupDialog(
            'ERROR',
            HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then(() => {});
      }
    );
  }

  private downloadApprovedLetter(degreeId: any, key: string): void {
    this.letterDownloadInFlight[key] = true;
    this.loader = true;
    this.loaderService.setValue(this.loader);
    const formName = 'DAS_approved_letter_' + key;
    this.approvedDetailService.generateLetterByDasDegreeId(degreeId, this.userCnic).subscribe(
      (blob: Blob) => {
        delete this.letterDownloadInFlight[key];
        this.loader = false;
        this.loaderService.setValue(this.loader);
        if (!blob || blob.size === 0) {
          this.sharedService
            .openPopupDialog(
              'ERROR',
              HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
              HEC_CONSTANTS.ERROR_TYPES.error
            )
            .then(() => {});
          return;
        }
        CommonHelper.downloadFileFromBlobNew(blob, 'application/pdf', `${formName}.pdf`);
      },
      () => {
        delete this.letterDownloadInFlight[key];
        this.loader = false;
        this.loaderService.setValue(this.loader);
        this.sharedService
          .openPopupDialog(
            'ERROR',
            HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then(() => {});
      }
    );
  }

  public async getApprovedApplicationDetails(appId):Promise<void>{
    try{
      this.loader=true;
      this.loaderService.setValue(this.loader)
      
      // const res = await this.approvedDetailService.getApprovedDetails(appId).toPromise()
      const res = await this.approvedDetailService.getApprovedDetailsForDas(appId).toPromise()
      if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
        this.approvedDetailsList =[];
        this.approvedDetailsList = res.data;
        this.applyStampColumnVisibilityFromFirstStampRow(this.approvedDetailsList);
        console.log(this.approvedDetailsList
          )
        this.loader=false;
        this.loaderService.setValue(this.loader)
      }else{      
        this.loader=false;
        this.loaderService.setValue(this.loader)
      }
    }catch(err){
      this.loader=false;
      this.loaderService.setValue(this.loader)
      console.log('err')
    }
  }

  setStep(index: number) {
    this.step = index;
  }

  /**
   * New DAS flow: first `stampDetails` row has `stampNumberFrom == null`.
   * Legacy rows carry a stamp number — keep stamp # and attestation type visible.
   */
  private applyStampColumnVisibilityFromFirstStampRow(approvedList: any): void {
    const firstStamp = this.getFirstStampDetailRow(approvedList);
    if (!firstStamp || typeof firstStamp !== 'object') {
      this.showStampNumberAndAttestationTypeColumns = true;
      this.showApprovedLetterColumn = false;
      return;
    }
    const from = firstStamp.stampNumberFrom;
    const isNewApplication = from === null || from === undefined || String(from).trim() === '';
    this.showStampNumberAndAttestationTypeColumns = !isNewApplication;
    this.showApprovedLetterColumn = isNewApplication;
  }

  private getFirstStampDetailRow(approvedList: any): any {
    if (!Array.isArray(approvedList) || approvedList.length === 0) {
      return null;
    }
    for (let i = 0; i < approvedList.length; i++) {
      const stampDetails = approvedList[i] && approvedList[i].stampDetails;
      if (Array.isArray(stampDetails) && stampDetails.length > 0) {
        return stampDetails[0];
      }
    }
    return null;
  }

  /** Prefer `data.cnic` from getPersonalDetails (profile API). */
  private extractCnicFromPersonalDetails(data: any): string {
    if (!data) {
      return '';
    }
    const raw = data.authenticationName;
    return raw != null && String(raw).trim() !== '' ? String(raw).trim() : '';
  }

  // public getDate(date): any {
	// 	if (date) {
	// 		let convertedDate = new Date(date).toISOString();
	// 		return convertedDate
	// 	} else {
	// 		return '';
	// 	}
	// }

  
}
